import { useState, useEffect, useRef } from "react";
import shopnavicon1 from '../../../assets/images/bonez_credit_pack5.png'
import shopnavicon2 from '../../../assets/images/power_card_box.webp'
import shopnavicon3 from '../../../assets/images/creditz_bridges.png'

import session from '../../../utils/nakama';
import CreateShopModal from './../components/ChipzShop.jsx';
import './ShopNav.css'

export default function Shop(props) {
    // const [showShopModal, setShowShopModalimp] = useState(false)
    const [showShopModal, setShowShopModal] = useState(false);
    const { isShopActive, toggleShopContent, setShowSuccessModal, setSuccessPackage, setZoomBalance } = props;
    const redirectToURL = () => {
        window.location.href = "https://zoombies.world/auth/bridge";
    };

    return (
        <>
            <CreateShopModal
                showShopModal={showShopModal}
                setShowShopModal={setShowShopModal}
                userId={session.user_id}
                setShowSuccessModal={setShowSuccessModal}
                setSuccessPackage={setSuccessPackage}
                setZoomBalance={setZoomBalance}
            />          
            <span className="container-body-text header-text">Shop</span>
            <div className="Shop-top">
                <img className="shopicon1" alt="" src={shopnavicon1} onClick={(e) => setShowShopModal(true)} />
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '5%', marginLeft:"12%"}}>
                    <span className="container-body-text shop" style={{ color: "gold", marginTop: "-1%" }} onClick={(e) => setShowShopModal(true)}>GET</span>
                    <span className="container-body-text shop" style={{ color: "gold", marginTop: "-10%" }} onClick={(e) => setShowShopModal(true)}>CHIPZ</span>
                </div>
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '5%' }}>
                <img className="shopicon2" alt="" src={shopnavicon2} onClick={toggleShopContent}/>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '5%', marginLeft:"12%"}}>
                    <span className="container-body-text shop" style={{ color: "#9370DB", marginTop: "1.5%" }} onClick={toggleShopContent}>GET</span>
                    <span className="container-body-text shop" style={{color: "#9370DB", marginTop: "-10%"}} onClick={toggleShopContent}>CARDS</span>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '5%' }}>
                <img className="shopicon3" alt="" src={shopnavicon3} onClick={redirectToURL}/>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '5%', marginLeft:"6%"}}>
                    <span className="container-body-text shop" style={{color: "#00D1FF", marginTop: "1.5%" }}onClick={redirectToURL}>EXCHANGE</span>
                    <span className="container-body-text shop" style={{color: "#00D1FF", marginTop: "-10%" }}onClick={redirectToURL}>TOKENS</span>
                </div>
            </div>
        </>
    )
}